import * as types from '../constants/ActionTypes';
import keyBy from 'lodash.keyby';

const initialState = {
  data: null
};

export default function profile(state = initialState, action) {
  switch (action.type) {
    case types.LOAD_COLLECTIONS_START:
      return { ...state };
    case types.LOAD_COLLECTIONS_SUCCESS:
      if (action.payload.updateOnlyTotal) {
        const collections = keyBy(action.payload.data, 'referal');
        const newState = { ...state, data: { ...state.data } };

        Object.keys(collections).forEach(referal => {
          if (newState.data[referal]) {
            newState.data[referal].total = collections[referal].total;
          }
        });

        return newState;
      }

      return { ...state, data: keyBy(action.payload.data, 'referal') };
    case types.LOAD_COLLECTIONS_ERROR:
      return { ...state, error: action.payload.error };

    case types.CREATE_COLLECTION_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.data.referal]: action.payload.data
        }
      };
    }

    case types.CREATE_COLLECTION_ERROR:
      return { ...state, error: action.payload.error };

    case types.DUP_COLLECTION_SUCCESS:
      return { ...state, data: { [action.payload.data.referal]: action.payload.data, ...state.data } };
    case types.DUP_COLLECTION_ERROR:
      return { ...state, error: action.payload.error };

    case types.ADD_TO_COLLECTION_SUCCESS: {
      if (state.data) {
        const collection = state.data[action.payload.referal];
        state.data[action.payload.referal] = { ...collection, includesCurrentBuilding: true };
        return { ...state, data: { ...state.data } };
      }
      return state;
    }

    case types.REMOVE_FROM_COLLECTION_SUCCESS: {
      const collection = state.data && state.data[action.payload.referal];
      if (collection) {
        state.data[action.payload.referal] = { ...collection, includesCurrentBuilding: false };
        return { ...state, data: { ...state.data } };
      }
      return state;
    }

    case types.DELETE_COLLECTION_SUCCESS:
      delete state.data[action.payload.referal];
      return { ...state, data: { ...state.data } };

    case types.DELETE_COLLECTION_ERROR:
      return { ...state, error: action.payload.error };

    case types.CHECK_BUILDING_SUCCESS:
      const data = { ...state.data };
      if (action.payload.data.selection) {
        action.payload.data.selection.forEach(
              ({ referal }) => { data[referal].includesCurrentBuilding = true; }
            );
      }
      return { ...state, data };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/collections.js